import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const opts = {
    theme: {
        options: {
            customProperties: true
        },
        dark: true,
        themes: {
            dark: {
                primary: colors.cyan.darken1,
                error: colors.red.lighten2
            }
        }
    }

}

export default new Vuetify(opts)


